<template>
    <Timeline 
        :value="value" 
        :align="timelineAlign" 
        :layout="timelineLayout"
        :pt="pt"
        :unstyled="unstyled"
        :aria-label="ariaLabel"
    >
        <template #content="slotProps">
            <slot name="content" :item="slotProps.item" :index="slotProps.index">
                <div class="card">
                    <h6 v-if="slotProps.item.status">{{ slotProps.item.status }}</h6>
                    <p>{{ slotProps.item.content }}</p>
                </div>
            </slot>
        </template>
        <template #opposite="slotProps">
            <slot name="opposite" :item="slotProps.item" :index="slotProps.index">
                {{ slotProps.item.date }}
            </slot>
        </template>
        <template #marker="slotProps">
            <slot name="marker" :item="slotProps.item" :index="slotProps.index">
                <span 
                    v-if="marker" 
                    :class="[slotProps.item.icon]"
                    :style="{ color: slotProps.item.color }"
                ></span>
            </slot>
        </template>
    </Timeline>
</template>

<script setup lang="ts">
import Timeline from 'primevue/timeline';
import { computed } from 'vue';
import { timelineProps } from './types';

const props = defineProps({
    ...timelineProps,
    pt: {
        type: Object,
        default: null
    },
    unstyled: {
        type: Boolean,
        default: false
    },
    ariaLabel: {
        type: String,
        default: 'Timeline'
    }
});

// Computed properties to ensure type safety
const timelineAlign = computed(() => props.align as 'left' | 'right' | 'alternate' | 'top' | 'bottom');
const timelineLayout = computed(() => props.layout as 'vertical' | 'horizontal');
</script>
